import React from "react";
import "./_index.scss";
import Page404 from "../../Components/Page404";

export default class extends React.Component {
    render() {
        return (
            <div className="page-404">
                <dwc-header />
                <div className="dwc-404">
                  <Page404 />
                </div>
                <dwc-footer />
            </div>
        )
    }
}
